import React, {Component} from "react"
import {connect} from "react-redux";
import {HashRouter as Router, Route, withRouter} from "react-router-dom";
import withStyles from "@mui/styles/withStyles";
import Login from "./Auth/Login";
import Register from "./Auth/Register";
import ForgotPassword from "./Auth/ForgotPassword";
import ResetPassword from "./Auth/ResetPassword";
import Container from "@mui/material/Container";
import logoDark from "../images/logo_dark.png";
import Card from "@mui/material/Card";
import {switchMode} from "../actions/theming";

const styles = theme => ({
    loginWrapper: {
        textAlign: "center",
        paddingTop: "40px",
        marginBottom: "60px",
        minHeight: "calc(100vh - 94px)",
        position: "relative",
        zIndex: 999,
    }
});


class Auth extends Component {

    render() {
        const {classes} = this.props;
        return (
            <>
                <Container component="main" maxWidth="xs" className={classes.loginWrapper}>
                    <img src={this.props.theming.darkMode ? logoDark : logoDark}
                         alt="Logo"
                         style={{marginBottom: '30px', width: "100%"}}
                    />
                    <Card style={{background: "none"}} elevation={0}>
                        <Router>
                            <Route exact path="/auth/login" component={Login}/>
                            <Route exact path="/auth/registration" component={Register}/>
                            <Route exact path="/auth/registration/terms" component={Register}/>
                            <Route exact path="/auth/registration/privacy-policy" component={Register}/>
                            <Route exact path="/auth/forgot-password" component={ForgotPassword}/>
                            <Route exact path="/auth/reset-password" component={ResetPassword}/>
                        </Router>
                    </Card>
                </Container>
            </>
        )
    }

}

const mapStateToProps = state => ({
    theming: state.theming
});

export default withRouter(withStyles(styles)(connect(
    mapStateToProps,
    {switchMode}
)(Auth)));
